import React from 'react'
import VisDiv from './frontend_components/VisDiv'
import { timePassedTranslated } from '../lib/utils'

/**
 * 
 * @param {*} date milliseconds format 
 * @returns date in eu format
 */

const DateLog = ({date, justDate, justObject, dateAndTime}) => {
  const dateObject = timePassedTranslated(date, justDate, dateAndTime)
  if(justObject) return dateObject
  return (
    <VisDiv style={{marginLeft:"3px", fontSize:"12px"}}> 
      {dateObject}
      
    </VisDiv>
  )
}

export default DateLog
